import React from "react";
import * as Funciones from "../../../../utils/funciones";
import styles from "./tabla-proyecciones-fu.module.css";

const TablaProyeccionesFU = ({ proyecciones, moneda }) => {
    return (
        <div className={styles.contenedor}>
            <div className={styles.gridHeader}>
                <div className={styles.ghAnio}>
                    Año
                </div>
                <div className={styles.ghEdad}>
                    Edad
                </div>
                <div className={styles.ghPrimaA}>
                    Prima anual
                </div>
                <div className={styles.ghPrimaAC}>
                    Prima acumulada
                </div>
                <div className={styles.ghSaldoCI}>
                    Saldo cuenta individual
                </div>
                <div className={styles.ghSaldoCE}>
                    Saldo cuenta de excedentes
                </div>
                <div className={styles.ghIA}>
                    Intereses excedentes acumulados
                </div>
                <div className={styles.ghValorR}>
                    Valor de rescate
                </div>
            </div>
            
            <div className={styles.body}>
                {proyecciones !== undefined && proyecciones.length > 0
                    ? Funciones.ordenarListaXCampo(true, proyecciones, 'anio').map((proyeccion, index) => (
                        <div key={'proyeccion_ap_' + index} className={styles.gridBody}>
                            <div className={styles.gbAnio}>
                                {proyeccion.anio}
                            </div>
                            <div className={styles.gbEdad}>
                                {proyeccion.edad}
                            </div>
                            <div className={styles.gbPrimaA}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.primaAnual, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbPrimaAC}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.primaAcumulada, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbSaldoCI}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.saldoCuentaIndividual, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbSaldoCE}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.saldoCuentaExcedente, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbIA}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.interesesExcedentesAcumulados, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbValorR}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.valorRescate, moneda.codigo, true)}
                            </div>
                        </div>
                    ))
                    : <div className={styles.label_no_data}>
                        <div className={styles.label_no_data_span}>No se encontraron registros.</div>
                    </div>
                }
            </div>
        </div>
    )
}

export default TablaProyeccionesFU;